import React from 'react';
import { Box, Flex, Spinner } from '@spothero/ui';
import { useSelector } from 'react-redux';
// Below has to be box not text as spinner is a div
const LoaderContent = ({ size, fontSize, fontWeight, children, }) => (<Box display="flex" alignItems="center" fontSize={fontSize} fontWeight={fontWeight}>
        <Spinner height={size} width={size} marginRight="1"/>
        {children || 'Loading'}
    </Box>);
// Would love to do a fade in animation
export const MapLoader = () => {
    const isPending = useSelector((state) => state.search.isPending);
    if (isPending) {
        return (<Flex position="absolute" 
        // Fill space then make sure its in the center
        width="100%" justifyContent="center" 
        // Base on the top then 6 down from there
        top="0" marginTop="6" 
        // Sit above the map
        zIndex="201" data-testid="map-loader">
                <Box paddingY="2" paddingX="3" backgroundColor="white" borderRadius="full" boxShadow="md">
                    <LoaderContent size={4} fontSize="sm" fontWeight="semibold"/>
                </Box>
            </Flex>);
    }
    return null;
};
